import { render } from "./BooksComposition.vue?vue&type=template&id=7d12e300&scoped=true"
import script from "./BooksComposition.vue?vue&type=script&lang=js"
export * from "./BooksComposition.vue?vue&type=script&lang=js"

import "./BooksComposition.vue?vue&type=style&index=0&id=7d12e300&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d12e300"]])

export default __exports__